import tokenStorage from '@/services/tokenStorage';
import AuthErrorInterceptor from './interceptors/AuthErrorInterceptor';
import api from './client';

if (tokenStorage.getAccessToken()) {
  api.setAuthorizationHeader(tokenStorage.getAccessToken());
}

api.mountInterceptor(new AuthErrorInterceptor());
